const scores = [
  '3',
  '5',
  '4',
  '3',
  '3',
  '4',
  '4',
  '4',
  '5',
  '4',
  '4',
  '4',
  '5',
  '5',
  '4',
  '3',
  '5',
  '5',
  '2',
  '1',
  '2',
  '2',
  '2',
  '3',
  '4',
  '2',
  '4',
  '5',
  '2',
  '2',
  '3',
  '5',
  '2',
  '4',
  '1',
  '2',
  '4',
  '3',
  '3',
  '4',
  '2',
  '4',
  '5',
  '2',
  '4',
  '3',
  '4',
  '',
  '',
  '4',
  '2',
  '3',
  '3',
  '5',
  '2',
  '4',
  '3',
  '5',
  '5',
  '5',
  '3',
  '5',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '1',
  '3',
  '4',
  '3',
  '5',
  '5',
  '3',
  '5',
  '5',
  '5',
  '3',
  '4',
  '5',
  '4',
  '4',
  '5',
  '5',
  '5',
  '4',
  '4',
  '5',
  '',
  '',
  '',
  '',
  '',
  '',
  '5',
  '5',
  '5',
  '5',
  '5',
  '5',
  '4',
  '5',
  '5',
  '5',
  '3',
  '5',
  '5',
  '5',
  '5',
  '5',
  '5',
  '3',
  '3',
  '5',
  '4',
  '5',
  '5',
  '',
  '',
  '5',
  '5',
  '5',
  '4',
  '5',
  '5',
  '5',
  '5',
  '5',
  '5',
  '5',
  '5',
  '5',
  '5',
  '4',
  '3',
  '2',
  '3',
  '3',
  '4',
  '4',
  '5',
  '5',
  '5',
  '5',
  '5',
  '',
  '3',
  '3',
  '3',
  '3',
  '3',
  '4',
  '3',
  '3',
  '4',
  '4',
  '4',
  '4',
  '4',
  '5',
  '4',
  '5',
  '5',
  '4',
  '5',
  '4',
  '5',
  '4',
  '3',
  '3',
  '5',
  '3',
  '3',
  '5',
  '3',
  '4',
  '4',
  '4',
  '5',
  '2',
  '4',
  '3',
  '3',
  '5',
  '3',
  '2',
  '5',
  '5',
  '3',
  '2',
  '2',
  '4',
  '',
  '',
  '',
  '4',
  '4',
  '3',
  '5',
  '4',
  '3',
  '4',
  '4',
  '3',
  '4',
  '2',
  '2',
  '4',
  '3',
  '3',
  '5',
  '3',
  '4',
  '3',
  '4',
  '4',
  '4',
  '4',
  '3',
  '3',
  '5',
  '3',
  '5',
  '4',
  '4',
  '5',
  '4',
  '',
  '4',
  '3',
  '5',
  '5',
  '5',
  '3',
  '3',
  '5',
  '',
  '',
  '',
  '',
  '3',
  '5',
  '5',
  '5',
  '4',
  '4',
  '',
  '',
  '4',
  '4',
  '4',
  '4',
  '',
  '4',
  '4',
  '4',
  '4',
  '4',
  '5',
  '5',
  '4',
  '3',
  '4',
  '4',
  '4',
  '4',
  '4',
  '4',
  '3',
  '4',
  '3',
  '3',
  '4',
  '3',
  '3',
  '4',
  '4',
  '3',
  '2',
  '5',
  '',
  '',
  '3',
  '3',
  '3',
  '4',
  '4',
  '4',
  '5',
  '5',
  '5',
  '5',
  '3',
  '3',
  '3',
  '',
  '5',
  '',
  '',
  '4',
  '3',
  '5',
  '5',
  '5',
  '4',
  '5',
  '3',
  '4',
  '5',
  '5',
  '3',
  '3',
  '5',
  '4',
  '4',
  '3',
  '5',
  '5',
];

const labelMap = {
  '': '未打分',
  1: '很差',
  2: '较差',
  3: '还行',
  4: '推荐',
  5: '力荐',
};

const typeMap = {
  '': 'black',
  1: 'error',
  2: 'warning',
  3: 'info',
  4: 'success',
  5: 'success',
};

const movie = [
  { content: '我是余欢水', label: '', type: '' },
  { content: '妖怪传', label: '', type: '' },
  { content: '魁拔之十万火急', label: '', type: '' },
  {
    content: '海王2：失落的王国 / Aquaman and the Lost Kingdom',
    label: '',
    type: '',
  },
  { content: '旺卡 / Wonka', label: '', type: '' },
  { content: '坠落 / Fall', label: '', type: '' },
  { content: '伊甸湖 / Eden Lake', label: '', type: '' },
  { content: '饥饿站台 / El hoyo', label: '', type: '' },
  { content: '罗拉快跑 / Lola rennt', label: '', type: '' },
  { content: '浪潮 / Die Welle', label: '', type: '' },
  { content: '恐怖游轮 / Triangle', label: '', type: '' },
  { content: '猫鼠游戏 / Catch Me If You Can', label: '', type: '' },
  { content: '蝙蝠侠：黑暗骑士 / The Dark Knight', label: '', type: '' },
  { content: '活着', label: '', type: '' },
  { content: '控方证人 / Witness for the Prosecution', label: '', type: '' },
  { content: '这个杀手不太冷 / Léon', label: '', type: '' },
  { content: '黄海 / 황해', label: '', type: '' },
  { content: '恐怖直播 / 더 테러 라이브', label: '', type: '' },
  { content: '一念天堂', label: '', type: '' },
  { content: '超能一家人', label: '', type: '' },
  { content: '温暖的抱抱', label: '', type: '' },
  { content: '四海', label: '', type: '' },
  { content: '李茶的姑妈', label: '', type: '' },
  { content: '疯狂的外星人', label: '', type: '' },
  { content: '独行月球', label: '', type: '' },
  { content: '羞羞的铁拳', label: '', type: '' },
  { content: '飞驰人生', label: '', type: '' },
  { content: '西虹市首富', label: '', type: '' },
  { content: '满江红', label: '', type: '' },
  { content: '逆鳞', label: '', type: '' },
  { content: '一雪前耻', label: '', type: '' },
  {
    content: '哥斯拉大战金刚2：帝国崛起 / Godzilla x Kong: The New Empire',
    label: '',
    type: '',
  },
  { content: '劫机 / 하이재킹', label: '', type: '' },
  { content: '重生', label: '', type: '' },
  { content: '饥饿站台2 / El hoyo 2', label: '', type: '' },
  {
    content: '猩球崛起：新世界 / Kingdom of the Planet of the Apes',
    label: '',
    type: '',
  },
  { content: '功夫熊猫4 / Kung Fu Panda 4', label: '', type: '' },
  { content: '浴火之路', label: '', type: '' },
  { content: '大场面', label: '', type: '' },
  { content: '九龙城寨之围城 / 九龍城寨·圍城', label: '', type: '' },
  { content: '狗阵', label: '', type: '' },
  { content: '飞驰人生2', label: '', type: '' },
  { content: '热辣滚烫', label: '', type: '' },
  { content: '默杀', label: '', type: '' },
  { content: '来福大酒店', label: '', type: '' },
  { content: '第二十条', label: '', type: '' },
  { content: '异形：夺命舰 / Alien: Romulus', label: '', type: '' },
  {
    content: '小黄人大眼萌：神偷奶爸前传 / Minions: The Rise of Gru',
    label: '',
    type: '',
  },
  { content: '神偷奶爸2 / Despicable Me 2', label: '', type: '' },
  { content: '神偷奶爸4 / Despicable Me 4', label: '', type: '' },
  { content: '胜券在握', label: '', type: '' },
  { content: '死侍与金刚狼 / Deadpool & Wolverine', label: '', type: '' },
  { content: '抓娃娃', label: '', type: '' },
  { content: '变形金刚：起源 / Transformers One', label: '', type: '' },
  { content: '毒液：最后一舞 / Venom: The Last Dance', label: '', type: '' },
  { content: '某种物质 / The Substance', label: '', type: '' },
  { content: '机器人之梦 / Robot Dreams', label: '', type: '' },
  { content: '年会不能停！', label: '', type: '' },
  { content: '周处除三害 / 周處除三害', label: '', type: '' },
  { content: '好东西', label: '', type: '' },
  { content: '误杀3', label: '', type: '' },
  { content: '哪吒之魔童闹海', label: '', type: '' },
  { content: '终结者 / The Terminator', label: '', type: '' },
  { content: '007：大破量子危机 / Quantum of Solace', label: '', type: '' },
  { content: '警察故事2013', label: '', type: '' },
  { content: '地心引力 / Gravity', label: '', type: '' },
  { content: '宿醉3 / The Hangover Part III', label: '', type: '' },
  { content: '死侍2：我爱我家 / Deadpool 2', label: '', type: '' },
  {
    content: '蝙蝠侠：黑暗骑士崛起 / The Dark Knight Rises',
    label: '',
    type: '',
  },
  { content: '叶问3', label: '', type: '' },
  { content: '蝙蝠侠：侠影之谜 / Batman Begins', label: '', type: '' },
  {
    content: '勇敢者游戏：决战丛林 / Jumanji: Welcome to the Jungle',
    label: '',
    type: '',
  },
  { content: '谍影重重4 / The Bourne Legacy', label: '', type: '' },
  { content: '碟中谍 / Mission: Impossible', label: '', type: '' },
  { content: '我是传奇 / I Am Legend', label: '', type: '' },
  {
    content: '生化危机：终章 / Resident Evil: The Final Chapter',
    label: '',
    type: '',
  },
  { content: '敢死队 / The Expendables', label: '', type: '' },
  {
    content: '生化危机4：战神再生 / Resident Evil: Afterlife',
    label: '',
    type: '',
  },
  {
    content: '生化危机3：灭绝 / Resident Evil: Extinction',
    label: '',
    type: '',
  },
  { content: '独立日 / Independence Day', label: '', type: '' },
  { content: '007：幽灵党 / Spectre', label: '', type: '' },
  { content: '自杀小队 / Suicide Squad', label: '', type: '' },
  { content: '全民超人汉考克 / Hancock', label: '', type: '' },
  { content: '神奇女侠 / Wonder Woman', label: '', type: '' },
  { content: '超体 / Lucy', label: '', type: '' },
  {
    content: '地心历险记 / Journey to the Center of the Earth',
    label: '',
    type: '',
  },
  { content: '碟中谍2 / Mission: Impossible II', label: '', type: '' },
  {
    content: '碟中谍4 / Mission: Impossible - Ghost Protocol',
    label: '',
    type: '',
  },
  {
    content: '生化危机5：惩罚 / Resident Evil: Retribution',
    label: '',
    type: '',
  },
  { content: '明日边缘 / Edge of Tomorrow', label: '', type: '' },
  { content: '碟中谍3 / Mission: Impossible III', label: '', type: '' },
  {
    content: '木乃伊3 / The Mummy: Tomb of the Dragon Emperor',
    label: '',
    type: '',
  },
  {
    content: '终结者3 / Terminator 3: Rise of the Machines',
    label: '',
    type: '',
  },
  { content: '速度与激情5 / Fast Five', label: '', type: '' },
  {
    content: '饥饿游戏2：星火燎原 / The Hunger Games: Catching Fire',
    label: '',
    type: '',
  },
  { content: '金蝉脱壳 / Escape Plan', label: '', type: '' },
  { content: '金刚：骷髅岛 / Kong: Skull Island', label: '', type: '' },
  {
    content: '变形金刚5：最后的骑士 / Transformers: The Last Knight',
    label: '',
    type: '',
  },
  {
    content: '饥饿游戏3：嘲笑鸟(上) / The Hunger Games: Mockingjay - Part 1',
    label: '',
    type: '',
  },
  {
    content: '地心历险记2：神秘岛 / Journey 2: The Mysterious Island',
    label: '',
    type: '',
  },
  { content: '正义联盟 / Justice League', label: '', type: '' },
  { content: '泰迪熊2 / Ted 2', label: '', type: '' },
  {
    content: '碟中谍5：神秘国度 / Mission: Impossible - Rogue Nation',
    label: '',
    type: '',
  },
  {
    content: '独立日2：卷土重来 / Independence Day: Resurgence',
    label: '',
    type: '',
  },
  { content: '暴力街区 / Brick Mansions', label: '', type: '' },
  {
    content: '蝙蝠侠大战超人：正义黎明 / Batman v Superman: Dawn of Justice',
    label: '',
    type: '',
  },
  { content: '环太平洋 / Pacific Rim', label: '', type: '' },
  { content: '变相怪杰 / The Mask', label: '', type: '' },
  { content: '超人归来 / Superman Returns', label: '', type: '' },
  { content: '终结者：创世纪 / Terminator Genisys', label: '', type: '' },
  { content: '死侍 / Deadpool', label: '', type: '' },
  { content: '惊天魔盗团 / Now You See Me', label: '', type: '' },
  { content: '憨豆特工 / Johnny English', label: '', type: '' },
  { content: "安德的游戏 / Ender's Game", label: '', type: '' },
  {
    content: '变形金刚3 / Transformers: Dark of the Moon',
    label: '',
    type: '',
  },
  { content: '十二生肖', label: '', type: '' },
  { content: '神奇四侠2015 / Fantastic Four', label: '', type: '' },
  { content: '超凡蜘蛛侠 / The Amazing Spider-Man', label: '', type: '' },
  { content: '像素大战 / Pixels', label: '', type: '' },
  { content: '功夫之王 / The Forbidden Kingdom', label: '', type: '' },
  {
    content: '冰河世纪：猛犸象的圣诞 / Ice Age: A Mammoth Christmas',
    label: '',
    type: '',
  },
  { content: '速度与激情6 / Furious 6', label: '', type: '' },
  { content: '侏罗纪公园3 / Jurassic Park III', label: '', type: '' },
  { content: '侏罗纪公园 / Jurassic Park', label: '', type: '' },
  {
    content: '侏罗纪公园2：失落的世界 / The Lost World: Jurassic Park',
    label: '',
    type: '',
  },
  {
    content: '变形金刚2 / Transformers: Revenge of the Fallen',
    label: '',
    type: '',
  },
  { content: '侏罗纪世界 / Jurassic World', label: '', type: '' },
  { content: '马达加斯加 / Madagascar', label: '', type: '' },
  {
    content: '猩球崛起3：终极之战 / War for the Planet of the Apes',
    label: '',
    type: '',
  },
  { content: '猩球崛起 / Rise of the Planet of the Apes', label: '', type: '' },
  { content: '魔兽 / Warcraft', label: '', type: '' },
  { content: '超凡蜘蛛侠2 / The Amazing Spider-Man 2', label: '', type: '' },
  { content: '神偷奶爸3 / Despicable Me 3', label: '', type: '' },
  {
    content: '猩球崛起2：黎明之战 / Dawn of the Planet of the Apes',
    label: '',
    type: '',
  },
  { content: '神奇四侠 / Fantastic Four', label: '', type: '' },
  { content: '蜘蛛侠3 / Spider-Man 3', label: '', type: '' },
  {
    content: '变形金刚4：绝迹重生 / Transformers: Age of Extinction',
    label: '',
    type: '',
  },
  { content: '黑衣人 / Men in Black', label: '', type: '' },
  { content: '赛车总动员3：极速挑战 / Cars 3', label: '', type: '' },
  { content: '黑衣人2 / Men in Black II', label: '', type: '' },
  { content: 'X战警：黑凤凰 / Dark Phoenix', label: '', type: '' },
  { content: '金刚狼3：殊死一战 / Logan', label: '', type: '' },
  { content: 'X战警：天启 / X-Men: Apocalypse', label: '', type: '' },
  {
    content: 'X战警：逆转未来 / X-Men: Days of Future Past',
    label: '',
    type: '',
  },
  { content: '金刚狼2 / The Wolverine', label: '', type: '' },
  { content: 'X战警3：背水一战 / X-Men: The Last Stand', label: '', type: '' },
  { content: 'X战警：第一战 / X-Men: First Class', label: '', type: '' },
  { content: 'X战警2 / X2', label: '', type: '' },
  { content: '金刚狼 / X-Men Origins: Wolverine', label: '', type: '' },
  { content: '绿巨人浩克 / Hulk', label: '', type: '' },
  { content: '怪兽大学 / Monsters University', label: '', type: '' },
  { content: '速度与激情4 / Fast & Furious', label: '', type: '' },
  { content: '毒液：致命守护者 / Venom', label: '', type: '' },
  { content: '蚁人2：黄蜂女现身 / Ant-Man and the Wasp', label: '', type: '' },
  { content: '黑豹 / Black Panther', label: '', type: '' },
  {
    content: '复仇者联盟3：无限战争 / Avengers: Infinity War',
    label: '',
    type: '',
  },
  { content: '雷神3：诸神黄昏 / Thor: Ragnarok', label: '', type: '' },
  { content: '蜘蛛侠：英雄归来 / Spider-Man: Homecoming', label: '', type: '' },
  {
    content: '银河护卫队2 / Guardians of the Galaxy Vol. 2',
    label: '',
    type: '',
  },
  { content: '奇异博士 / Doctor Strange', label: '', type: '' },
  { content: '美国队长3 / Captain America: Civil War', label: '', type: '' },
  { content: '蚁人 / Ant-Man', label: '', type: '' },
  {
    content: '复仇者联盟2：奥创纪元 / Avengers: Age of Ultron',
    label: '',
    type: '',
  },
  { content: '银河护卫队 / Guardians of the Galaxy', label: '', type: '' },
  {
    content: '美国队长2 / Captain America: The Winter Soldier',
    label: '',
    type: '',
  },
  { content: '雷神2：黑暗世界 / Thor: The Dark World', label: '', type: '' },
  { content: '钢铁侠3 / Iron Man 3', label: '', type: '' },
  {
    content: '美国队长 / Captain America: The First Avenger',
    label: '',
    type: '',
  },
  { content: '雷神 / Thor', label: '', type: '' },
  { content: '无敌浩克 / The Incredible Hulk', label: '', type: '' },
  { content: '钢铁侠 / Iron Man', label: '', type: '' },
  {
    content: '蜘蛛侠：英雄远征 / Spider-Man: Far from Home',
    label: '',
    type: '',
  },
  { content: '复仇者联盟4：终局之战 / Avengers: Endgame', label: '', type: '' },
  { content: '惊奇队长 / Captain Marvel', label: '', type: '' },
  { content: '复仇者联盟 / The Avengers', label: '', type: '' },
  { content: '蜘蛛侠2 / Spider-Man 2', label: '', type: '' },
  { content: '钢铁侠2 / Iron Man 2', label: '', type: '' },
  {
    content: '霍比特人1：意外之旅 / The Hobbit: An Unexpected Journey',
    label: '',
    type: '',
  },
  {
    content:
      '加勒比海盗5：死无对证 / Pirates of the Caribbean: Dead Men Tel...',
    label: '',
    type: '',
  },
  {
    content: '博物馆奇妙夜3 / Night at the Museum: Secret of the Tomb',
    label: '',
    type: '',
  },
  { content: '博物馆奇妙夜 / Night at the Museum', label: '', type: '' },
  { content: '变形金刚 / Transformers', label: '', type: '' },
  {
    content: '霍比特人2：史矛革之战 / The Hobbit: The Desolation of Smaug',
    label: '',
    type: '',
  },
  { content: '海底总动员 / Finding Nemo', label: '', type: '' },
  { content: '超人总动员 / The Incredibles', label: '', type: '' },
  { content: '蜘蛛侠 / Spider-Man', label: '', type: '' },
  { content: '小黄人大眼萌 / Minions', label: '', type: '' },
  { content: '赛车总动员 / Cars', label: '', type: '' },
  { content: 'X战警 / X-Men', label: '', type: '' },
  {
    content: '霍比特人3：五军之战 / The Hobbit: The Battle of the Five Armies',
    label: '',
    type: '',
  },
  { content: '倚天屠龙记', label: '', type: '' },
  { content: '马达加斯加的企鹅 / Penguins of Madagascar', label: '', type: '' },
  { content: '功夫熊猫 / Kung Fu Panda', label: '', type: '' },
  { content: '功夫熊猫2 / Kung Fu Panda 2', label: '', type: '' },
  {
    content:
      '加勒比海盗 / Pirates of the Caribbean: The Curse of the Black ...',
    label: '',
    type: '',
  },
  { content: '功夫熊猫3 / Kung Fu Panda 3', label: '', type: '' },
  {
    content: '冰川时代3 / Ice Age: Dawn of the Dinosaurs',
    label: '',
    type: '',
  },
  { content: '冰川时代4 / Ice Age: Continental Drift', label: '', type: '' },
  { content: '冰川时代2 / Ice Age: The Meltdown', label: '', type: '' },
  {
    content: '冰川时代5：星际碰撞 / Ice Age: Collision Course',
    label: '',
    type: '',
  },
  {
    content:
      "加勒比海盗2：亡灵的宝藏 / Pirates of the Caribbean: Dead Man's...",
    label: '',
    type: '',
  },
  { content: '赌神 / 賭神', label: '', type: '' },
  { content: '火星救援 / The Martian', label: '', type: '' },
  { content: '美人鱼', label: '', type: '' },
  {
    content: '权力的游戏：征服与反抗 / Game of Thrones: Conquest and Rebellion',
    label: '',
    type: '',
  },
  {
    content: '两杆大烟枪 / Lock, Stock and Two Smoking Barrels',
    label: '',
    type: '',
  },
  { content: '重庆森林 / 重慶森林', label: '', type: '' },
  { content: '窃听风暴 / Das Leben der Anderen', label: '', type: '' },
  { content: '玩具总动员 / Toy Story', label: '', type: '' },
  { content: '冰雪奇缘 / Frozen', label: '', type: '' },
  { content: '魁拔之大战元泱界', label: '', type: '' },
  { content: '新龙门客栈 / 新龍門客棧', label: '', type: '' },
  { content: '汽车人总动员', label: '', type: '' },
  { content: '血钻 / Blood Diamond', label: '', type: '' },
  { content: '夏洛特烦恼', label: '', type: '' },
  { content: '长江七号', label: '', type: '' },
  { content: '西游记之大圣归来', label: '', type: '' },
  { content: '大宅门', label: '', type: '' },
  { content: '了不起的盖茨比 / The Great Gatsby', label: '', type: '' },
  { content: '黑客帝国 / The Matrix', label: '', type: '' },
  { content: '禁闭岛 / Shutter Island', label: '', type: '' },
  { content: '举起手来！', label: '', type: '' },
  { content: '沉默的羔羊 / The Silence of the Lambs', label: '', type: '' },
  { content: '拯救大兵瑞恩 / Saving Private Ryan', label: '', type: '' },
  { content: '卢旺达饭店 / Hotel Rwanda', label: '', type: '' },
  { content: '教父2 / The Godfather: Part II', label: '', type: '' },
  { content: '教父3 / The Godfather: Part III', label: '', type: '' },
  { content: '绿里奇迹 / The Green Mile', label: '', type: '' },
  { content: '幸福终点站 / The Terminal', label: '', type: '' },
  {
    content: '指环王2：双塔奇兵 / The Lord of the Rings: The Two Towers',
    label: '',
    type: '',
  },
  {
    content:
      '指环王3：王者无敌 / The Lord of the Rings: The Return of the King',
    label: '',
    type: '',
  },
  { content: '钢琴家 / The Pianist', label: '', type: '' },
  {
    content:
      '指环王1：护戒使者 / The Lord of the Rings: The Fellowship of t...',
    label: '',
    type: '',
  },
  { content: '无敌破坏王 / Wreck-It Ralph', label: '', type: '' },
  { content: '教父 / The Godfather', label: '', type: '' },
  { content: '鬼子来了', label: '', type: '' },
  { content: '玩具总动员3 / Toy Story 3', label: '', type: '' },
  { content: '贫民窟的百万富翁 / Slumdog Millionaire', label: '', type: '' },
  { content: '九品芝麻官', label: '', type: '' },
  { content: '冰川时代 / Ice Age', label: '', type: '' },
  { content: '倩女幽魂', label: '', type: '' },
  { content: '济公', label: '', type: '' },
  { content: '放牛班的春天 / Les choristes', label: '', type: '' },
  { content: '流浪地球', label: '', type: '' },
  { content: '天堂电影院 / Nuovo Cinema Paradiso', label: '', type: '' },
  { content: '哈尔的移动城堡 / ハウルの動く城', label: '', type: '' },
  { content: '喜剧之王 / 喜劇之王', label: '', type: '' },
  { content: '死亡诗社 / Dead Poets Society', label: '', type: '' },
  { content: '无名之辈', label: '', type: '' },
  { content: '爆裂鼓手 / Whiplash', label: '', type: '' },
  { content: '功夫', label: '', type: '' },
  {
    content: "哈利·波特与魔法石 / Harry Potter and the Sorcerer's Stone",
    label: '',
    type: '',
  },
  { content: '唐伯虎点秋香 / 唐伯虎點秋香', label: '', type: '' },
  { content: '百鸟朝凤', label: '', type: '' },
  { content: '驯龙高手 / How to Train Your Dragon', label: '', type: '' },
  { content: '心灵捕手 / Good Will Hunting', label: '', type: '' },
  { content: '罗小黑战记', label: '', type: '' },
  { content: '盗梦空间 / Inception', label: '', type: '' },
  { content: '机器人总动员 / WALL·E', label: '', type: '' },
  { content: "辛德勒的名单 / Schindler's List", label: '', type: '' },
  { content: '西西里的美丽传说 / Malèna', label: '', type: '' },
  { content: '神偷奶爸 / Despicable Me', label: '', type: '' },
  { content: '血战钢锯岭 / Hacksaw Ridge', label: '', type: '' },
  { content: '看不见的客人 / Contratiempo', label: '', type: '' },
  { content: '海蒂和爷爷 / Heidi', label: '', type: '' },
  {
    content: '大话西游之月光宝盒 / 西遊記第壹佰零壹回之月光寶盒',
    label: '',
    type: '',
  },
  { content: '釜山行 / 부산행', label: '', type: '' },
  {
    content: '一个叫欧维的男人决定去死 / En man som heter Ove',
    label: '',
    type: '',
  },
  { content: '驴得水', label: '', type: '' },
  { content: '少年派的奇幻漂流 / Life of Pi', label: '', type: '' },
  { content: '何以为家 / كفرناحوم', label: '', type: '' },
  { content: '超能陆战队 / Big Hero 6', label: '', type: '' },
  { content: '触不可及 / Intouchables', label: '', type: '' },
  { content: '你好，李焕英', label: '', type: '' },
  { content: '阿凡达 / Avatar', label: '', type: '' },
  { content: '你的名字。 / 君の名は。', label: '', type: '' },
  { content: '当幸福来敲门 / The Pursuit of Happyness', label: '', type: '' },
  {
    content: '大话西游之大圣娶亲 / 西遊記大結局之仙履奇緣',
    label: '',
    type: '',
  },
  { content: '摔跤吧！爸爸 / Dangal', label: '', type: '' },
  { content: '绿皮书 / Green Book', label: '', type: '' },
  {
    content: "海上钢琴师 / La leggenda del pianista sull'oceano",
    label: '',
    type: '',
  },
  { content: '让子弹飞', label: '', type: '' },
  { content: '寻梦环游记 / Coco', label: '', type: '' },
  { content: '楚门的世界 / The Truman Show', label: '', type: '' },
  { content: '哪吒之魔童降世', label: '', type: '' },
  { content: '三傻大闹宝莱坞 / 3 Idiots', label: '', type: '' },
  { content: '星际穿越 / Interstellar', label: '', type: '' },
  { content: '疯狂动物城 / Zootopia', label: '', type: '' },
  { content: '我不是药神', label: '', type: '' },
  { content: '霸王别姬', label: '', type: '' },
  { content: '阿甘正传 / Forrest Gump', label: '', type: '' },
  { content: '千与千寻 / 千と千尋の神隠し', label: '', type: '' },
  { content: '肖申克的救赎 / The Shawshank Redemption', label: '', type: '' },
  { content: '唐探1900', label: '', type: '' },
  { content: '湮灭 / Annihilation', label: '', type: '' },
  {
    content: '成龙历险记 第二季 / Jackie Chan Adventures Season 2',
    label: '',
    type: '',
  },
  { content: '天赋异禀 第二季 / The Gifted Season 2', label: '', type: '' },
  { content: '马丁的早晨', label: '', type: '' },
  {
    content: '齐木楠雄的灾难 完结篇 / 斉木楠雄のΨ難 完結編',
    label: '',
    type: '',
  },
  { content: '小鲤鱼历险记', label: '', type: '' },
  { content: '洛基 第二季 / Loki Season 2', label: '', type: '' },
  {
    content: '成龙历险记 第一季 / Jackie Chan Adventures Season 1',
    label: '',
    type: '',
  },
  {
    content: '齐木楠雄的灾难 第二季 / 斉木楠雄のΨ難 第2期',
    label: '',
    type: '',
  },
  { content: '天赋异禀 第一季 / The Gifted Season 1', label: '', type: '' },
  { content: '哪吒传奇', label: '', type: '' },
  {
    content: '海绵宝宝 第一季 / SpongeBob SquarePants Season 1',
    label: '',
    type: '',
  },
  { content: '魔幻手机', label: '', type: '' },
  { content: '一人之下 第二季', label: '', type: '' },
  { content: '罗小黑战记', label: '', type: '' },
  { content: '一人之下 第一季', label: '', type: '' },
  { content: '洛基 第一季 / Loki Season 1', label: '', type: '' },
  { content: '咒术回战 / 呪術廻戦', label: '', type: '' },
  {
    content: '弥留之国的爱丽丝 第一季 / 今際の国のアリス',
    label: '',
    type: '',
  },
  { content: '鬼灭之刃 / 鬼滅の刃', label: '', type: '' },
  {
    content: '权力的游戏 第七季 / Game of Thrones Season 7',
    label: '',
    type: '',
  },
  {
    content: '权力的游戏 第八季 / Game of Thrones Season 8',
    label: '',
    type: '',
  },
  {
    content: '权力的游戏 第六季 / Game of Thrones Season 6',
    label: '',
    type: '',
  },
  {
    content: '权力的游戏 第五季 / Game of Thrones Season 5',
    label: '',
    type: '',
  },
  {
    content: '权力的游戏 第四季 / Game of Thrones Season 4',
    label: '',
    type: '',
  },
  {
    content: '权力的游戏 第三季 / Game of Thrones Season 3',
    label: '',
    type: '',
  },
  {
    content: '权力的游戏  第二季 / Game of Thrones Season 2',
    label: '',
    type: '',
  },
  { content: '仙剑奇侠传三', label: '', type: '' },
  { content: '仙剑奇侠传', label: '', type: '' },
  { content: '神探夏洛克  第二季 / Sherlock Season 2', label: '', type: '' },
  { content: '浴血黑帮 第一季 / Peaky Blinders Season 1', label: '', type: '' },
  { content: '9号秘事 第一季 / Inside No. 9 Season 1', label: '', type: '' },
  { content: '唐顿庄园  第一季 / Downton Abbey Season 1', label: '', type: '' },
  { content: '黑镜 第一季 / Black Mirror Season 1', label: '', type: '' },
  { content: '神探夏洛克 第一季 / Sherlock Season 1', label: '', type: '' },
  { content: '毒枭 第一季 / Narcos Season 1', label: '', type: '' },
  {
    content: '怪奇物语 第一季 / Stranger Things Season 1',
    label: '',
    type: '',
  },
  { content: '纸牌屋 第一季 / House of Cards Season 1', label: '', type: '' },
  { content: '越狱 第一季 / Prison Break Season 1', label: '', type: '' },
  {
    content: '权力的游戏 第一季 / Game of Thrones Season 1',
    label: '',
    type: '',
  },
  { content: '老友记 第一季 / Friends Season 1', label: '', type: '' },
  { content: '夏日重现 / サマータイムレンダ', label: '', type: '' },
  {
    content: '最后生还者 第一季 / The Last of Us Season 1',
    label: '',
    type: '',
  },
  { content: '浴血黑帮 第六季 / Peaky Blinders Season 6', label: '', type: '' },
  { content: '超异能族 / 무빙', label: '', type: '' },
  { content: '间谍过家家 第二季 / SPY×FAMILY Season 2', label: '', type: '' },
  {
    content: '无耻之徒(美版) 第十一季 / Shameless Season 11',
    label: '',
    type: '',
  },
  { content: '拾荒者统治 / Scavengers Reign', label: '', type: '' },
  { content: '9号秘事 第九季 / Inside No. 9 Season 9', label: '', type: '' },
  {
    content: '风骚律师 第六季 / Better Call Saul Season 6',
    label: '',
    type: '',
  },
  {
    content: '风骚律师 第四季 / Better Call Saul Season 4',
    label: '',
    type: '',
  },
  {
    content: '风骚律师 第五季 / Better Call Saul Season 5',
    label: '',
    type: '',
  },
  {
    content: '风骚律师 第三季 / Better Call Saul Season 3',
    label: '',
    type: '',
  },
  {
    content: '风骚律师 第二季 / Better Call Saul Season 2',
    label: '',
    type: '',
  },
  {
    content: '风骚律师 第一季 / Better Call Saul Season 1',
    label: '',
    type: '',
  },
  { content: '绝命毒师  第五季 / Breaking Bad Season 5', label: '', type: '' },
  { content: '绝命毒师  第四季 / Breaking Bad Season 4', label: '', type: '' },
  { content: '绝命毒师  第三季 / Breaking Bad Season 3', label: '', type: '' },
  { content: '绝命毒师  第二季 / Breaking Bad Season 2', label: '', type: '' },
  { content: '绝命毒师 第一季 / Breaking Bad Season 1', label: '', type: '' },
  {
    content: '英雄联盟：双城之战 第二季 / Arcane Season 2',
    label: '',
    type: '',
  },
  {
    content: '英雄联盟：双城之战 第一季 / Arcane Season 1',
    label: '',
    type: '',
  },
  {
    content: '爱，死亡和机器人 第三季 / Love, Death & Robots Season 3',
    label: '',
    type: '',
  },
  {
    content: '爱，死亡和机器人 第二季 / Love, Death & Robots Season 2',
    label: '',
    type: '',
  },
  {
    content: '爱，死亡和机器人 第一季 / Love, Death & Robots Season 1',
    label: '',
    type: '',
  },
  { content: '“骗骗”喜欢你', label: '', type: '' },
  { content: '汉尼拔 / Hannibal', label: '', type: '' },
  { content: '消失的她', label: '', type: '' },
  { content: '孤注一掷', label: '', type: '' },
  { content: '老枪', label: '', type: '' },
  { content: '鹊刀门传奇', label: '', type: '' },
  { content: '剑雨', label: '', type: '' },
  { content: '电话 / 콜', label: '', type: '' },
  { content: '芬奇 / Finch', label: '', type: '' },
  { content: '子弹列车 / Bullet Train', label: '', type: '' },
  { content: '史密斯夫妇 / Mr. & Mrs. Smith', label: '', type: '' },
  {
    content: '本杰明·巴顿奇事 / The Curious Case of Benjamin Button',
    label: '',
    type: '',
  },
  {
    content: '侏罗纪世界2 / Jurassic World: Fallen Kingdom',
    label: '',
    type: '',
  },
  { content: '侏罗纪世界3 / Jurassic World: Dominion', label: '', type: '' },
  {
    content:
      '奇异博士2：疯狂多元宇宙 / Doctor Strange in the Multiverse of ...',
    label: '',
    type: '',
  },
  { content: '黑豹2 / Black Panther: Wakanda Forever', label: '', type: '' },
  {
    content: '蚁人与黄蜂女：量子狂潮 / Ant-Man and the Wasp: Quantumania',
    label: '',
    type: '',
  },
  {
    content: '雷霆沙赞！众神之怒 / Shazam! Fury of the Gods',
    label: '',
    type: '',
  },
  {
    content: '超级马力欧兄弟大电影 / The Super Mario Bros. Movie',
    label: '',
    type: '',
  },
  {
    content: '变形金刚：超能勇士崛起 / Transformers: Rise of the Beasts',
    label: '',
    type: '',
  },
  { content: '土拨鼠之日 / Groundhog Day', label: '', type: '' },
  { content: '白日焰火', label: '', type: '' },
  { content: '绣春刀', label: '', type: '' },
  { content: '解救吾先生', label: '', type: '' },
  { content: '师父', label: '', type: '' },
  { content: '老炮儿', label: '', type: '' },
  { content: '心迷宫', label: '', type: '' },
  {
    content: '神奇动物在哪里 / Fantastic Beasts and Where to Find Them',
    label: '',
    type: '',
  },
  { content: '追凶者也', label: '', type: '' },
  { content: '暴裂无声', label: '', type: '' },
  { content: '无双 / 無雙', label: '', type: '' },
  {
    content: '蜘蛛侠：平行宇宙 / Spider-Man: Into the Spider-Verse',
    label: '',
    type: '',
  },
  { content: '波西米亚狂想曲 / Bohemian Rhapsody', label: '', type: '' },
  { content: '寄生虫 / 기생충', label: '', type: '' },
  { content: '误杀', label: '', type: '' },
  { content: '少年的你', label: '', type: '' },
  { content: '沙丘 / Dune', label: '', type: '' },
  { content: '失控玩家 / Free Guy', label: '', type: '' },
  { content: 'X特遣队：全员集结 / The Suicide Squad', label: '', type: '' },
  {
    content: "扎克·施奈德版正义联盟 / Zack Snyder's Justice League",
    label: '',
    type: '',
  },
  { content: '扬名立万', label: '', type: '' },
  { content: '阿凡达：水之道 / Avatar: The Way of Water', label: '', type: '' },
  { content: '俄罗斯方块 / Tetris', label: '', type: '' },
  {
    content: '穿靴子的猫2 / Puss in Boots: The Last Wish',
    label: '',
    type: '',
  },
  {
    content: '银河护卫队3 / Guardians of the Galaxy Vol. 3',
    label: '',
    type: '',
  },
  {
    content: '蜘蛛侠：纵横宇宙 / Spider-Man: Across the Spider-Verse',
    label: '',
    type: '',
  },
  { content: '奥本海默 / Oppenheimer', label: '', type: '' },
  { content: '保你平安', label: '', type: '' },
  { content: '三大队', label: '', type: '' },
  { content: '封神第一部：朝歌风云', label: '', type: '' },
  { content: '宇宙探索编辑部', label: '', type: '' },
  { content: '长安三万里', label: '', type: '' },
  { content: '流浪地球2', label: '', type: '' },
  {
    content: '白日梦想家 / The Secret Life of Walter Mitty',
    label: '',
    type: '',
  },
  { content: '头号玩家 / Ready Player One', label: '', type: '' },
  { content: '犯罪都市4 / 범죄도시4', label: '', type: '' },
  { content: '小丑2：双重妄想 / Joker: Folie à Deux', label: '', type: '' },
  { content: '涉过愤怒的海', label: '', type: '' },
  {
    content: '间谍过家家 代号：白 / 劇場版 Spy x Family Code: White',
    label: '',
    type: '',
  },
  { content: '谍影重重5 / Jason Bourne', label: '', type: '' },
  { content: '谍影重重2 / The Bourne Supremacy', label: '', type: '' },
  { content: '谍影重重 / The Bourne Identity', label: '', type: '' },
  { content: '谍影重重3 / The Bourne Ultimatum', label: '', type: '' },
  { content: '角斗士 / Gladiator', label: '', type: '' },
  { content: '角斗士2 / Gladiator II', label: '', type: '' },
  { content: '疯狂的石头', label: '', type: '' },
  { content: '无人区', label: '', type: '' },
  { content: '港囧', label: '', type: '' },
  { content: '煎饼侠', label: '', type: '' },
  { content: '捉妖记', label: '', type: '' },
  { content: '恶棍天使', label: '', type: '' },
  { content: '爱宠大机密 / The Secret Life of Pets', label: '', type: '' },
  { content: '万万没想到', label: '', type: '' },
  { content: '捉妖记2', label: '', type: '' },
  { content: '火锅英雄', label: '', type: '' },
  { content: '逃出绝命镇 / Get Out', label: '', type: '' },
  { content: '乘风破浪', label: '', type: '' },
  { content: '华尔街之狼 / The Wolf of Wall Street', label: '', type: '' },
  { content: '爱宠大机密2 / The Secret Life of Pets 2', label: '', type: '' },
  {
    content:
      '神奇动物：格林德沃之罪 / Fantastic Beasts: The Crimes of Grind...',
    label: '',
    type: '',
  },
  { content: '人生路不熟', label: '', type: '' },
  { content: '缝纫机乐队', label: '', type: '' },
  { content: '唐人街探案', label: '', type: '' },
  { content: '天才枪手 / ฉลาดเกมส์โกง', label: '', type: '' },
  {
    content: '无敌破坏王2：大闹互联网 / Ralph Breaks the Internet',
    label: '',
    type: '',
  },
  { content: '唐人街探案2', label: '', type: '' },
  { content: '唐人街探案3', label: '', type: '' },
  { content: '一出好戏', label: '', type: '' },
  { content: '人潮汹涌', label: '', type: '' },
  { content: '这个杀手不太冷静', label: '', type: '' },
  { content: '不速来客', label: '', type: '' },
  { content: '美丽心灵 / A Beautiful Mind', label: '', type: '' },
  {
    content:
      '辉夜大小姐想让我告白：初吻不会结束 / かぐや様は告らせたい-ファ...',
    label: '',
    type: '',
  },
  { content: '哥斯拉 / Godzilla', label: '', type: '' },
  { content: '驯龙高手2 / How to Train Your Dragon 2', label: '', type: '' },
  {
    content: '驯龙高手3 / How to Train Your Dragon: The Hidden World',
    label: '',
    type: '',
  },
  {
    content: '龙与地下城：侠盗荣耀 / Dungeons & Dragons: Honor Among Thieves',
    label: '',
    type: '',
  },
  {
    content:
      '神探夏洛克：福至如归 / Sherlock Mini Episode - Many Happy Returns',
    label: '',
    type: '',
  },
  { content: '第十一回', label: '', type: '' },
  { content: '意外空间 / El Incidente', label: '', type: '' },
  { content: '破风 / 破風', label: '', type: '' },
  { content: '夜行动物 / Nocturnal Animals', label: '', type: '' },
  { content: '亮剑', label: '', type: '' },
  {
    content: '无耻之徒(美版) 第八季 / Shameless Season 8',
    label: '',
    type: '',
  },
  {
    content: '无耻之徒(美版) 第七季 / Shameless Season 7',
    label: '',
    type: '',
  },
  {
    content: '无耻之徒(美版) 第六季 / Shameless Season 6',
    label: '',
    type: '',
  },
  {
    content: '无耻之徒(美版) 第五季 / Shameless Season 5',
    label: '',
    type: '',
  },
  {
    content: '无耻之徒(美版) 第九季 / Shameless Season 9',
    label: '',
    type: '',
  },
  { content: '老友记  第四季 / Friends Season 4', label: '', type: '' },
  { content: '老友记  第三季 / Friends Season 3', label: '', type: '' },
  { content: '老友记 第二季 / Friends Season 2', label: '', type: '' },
  { content: '咒术回战 第二季 / 呪術廻戦 2', label: '', type: '' },
  { content: '黄石 第五季 / Yellowstone Season 5', label: '', type: '' },
  { content: '黑袍纠察队 第二季 / The Boys Season 2', label: '', type: '' },
  { content: '黑袍纠察队 第一季 / The Boys Season 1', label: '', type: '' },
  { content: '黑袍纠察队 第三季 / The Boys Season 3', label: '', type: '' },
  { content: '破墓 / 파묘', label: '', type: '' },
  { content: '太极张三丰 / 太極張三豐', label: '', type: '' },
  { content: '武状元苏乞儿 / 武狀元蘇乞兒', label: '', type: '' },
  { content: '鹿鼎记2：神龙教 / 鹿鼎記II 神龍教', label: '', type: '' },
  { content: '萨利机长 / Sully', label: '', type: '' },
  { content: '汉江怪物 / 괴물', label: '', type: '' },
  { content: '雪国列车 / 설국열차', label: '', type: '' },
  {
    content: '哥斯拉2：怪兽之王 / Godzilla: King of the Monsters',
    label: '',
    type: '',
  },
  { content: '超人：钢铁之躯 / Man of Steel', label: '', type: '' },
  {
    content: '生化危机2：启示录 / Resident Evil: Apocalypse',
    label: '',
    type: '',
  },
  { content: '生化危机 / Resident Evil', label: '', type: '' },
  { content: '落叶归根', label: '', type: '' },
  { content: '我和我的祖国', label: '', type: '' },
  { content: '爱丽丝梦游仙境 / Alice in Wonderland', label: '', type: '' },
  { content: '兰戈 / Rango', label: '', type: '' },
  { content: '赛车总动员2 / Cars 2', label: '', type: '' },
  { content: '穿靴子的猫 / Puss in Boots', label: '', type: '' },
  { content: '快乐的大脚 / Happy Feet', label: '', type: '' },
  { content: '快乐的大脚2 / Happy Feet Two', label: '', type: '' },
  { content: '僵尸世界大战 / World War Z', label: '', type: '' },
  { content: '奇幻森林 / The Jungle Book', label: '', type: '' },
  { content: '长城 / The Great Wall', label: '', type: '' },
  { content: '狂暴巨兽 / Rampage', label: '', type: '' },
  { content: '海王 / Aquaman', label: '', type: '' },
  {
    content: '猛禽小队和哈莉·奎茵 / Birds of Prey: And the Fantabulous Eman...',
    label: '',
    type: '',
  },
  { content: '毒液2 / Venom: Let There Be Carnage', label: '', type: '' },
  {
    content: '蜘蛛侠：英雄无归 / Spider-Man: No Way Home',
    label: '',
    type: '',
  },
  { content: '哥斯拉大战金刚 / Godzilla vs Kong', label: '', type: '' },
  { content: '雷霆沙赞！ / Shazam!', label: '', type: '' },
  { content: '雷神4：爱与雷霆 / Thor: Love and Thunder', label: '', type: '' },
  { content: '源代码 / Source Code', label: '', type: '' },
  { content: '叶问4：完结篇 / 葉問4：完結篇', label: '', type: '' },
  { content: '叶问 / 葉問', label: '', type: '' },
  { content: '叶问2：宗师传奇 / 葉問2', label: '', type: '' },
  { content: '伸冤人 / The Equalizer', label: '', type: '' },
  { content: '战狼2', label: '', type: '' },
  { content: '敢死队3 / The Expendables 3', label: '', type: '' },
  { content: '敢死队2 / The Expendables 2', label: '', type: '' },
  { content: '湄公河行动', label: '', type: '' },
  { content: '被解救的姜戈 / Django Unchained', label: '', type: '' },
  { content: '阿丽塔：战斗天使 / Alita: Battle Angel', label: '', type: '' },
  { content: '天下无贼', label: '', type: '' },
  { content: '人在囧途', label: '', type: '' },
  { content: '人再囧途之泰囧', label: '', type: '' },
  { content: '西游降魔篇', label: '', type: '' },
  { content: '厨子戏子痞子', label: '', type: '' },
  { content: '警察故事', label: '', type: '' },
  { content: '私人订制', label: '', type: '' },
  { content: '新警察故事', label: '', type: '' },
  { content: '鹿鼎记 / 鹿鼎記', label: '', type: '' },
  { content: '赌侠 / 賭俠', label: '', type: '' },
  { content: '花好月圆', label: '', type: '' },
  { content: '赌神2 / 賭神2', label: '', type: '' },
  { content: '食神', label: '', type: '' },
  { content: '大内密探零零发 / 大內密探零零發', label: '', type: '' },
  { content: '绣春刀II：修罗战场', label: '', type: '' },
  { content: '荒蛮故事 / Relatos salvajes', label: '', type: '' },
  { content: '十二公民', label: '', type: '' },
  { content: '智取威虎山', label: '', type: '' },
  { content: '烈日灼心', label: '', type: '' },
  { content: '我不是王毛', label: '', type: '' },
  { content: '杀破狼2 / 殺破狼2', label: '', type: '' },
  { content: '使徒行者', label: '', type: '' },
  { content: '寒战 / 寒戰', label: '', type: '' },
  { content: '追龙 / 追龍', label: '', type: '' },
  { content: '寒战2 / 寒戰II', label: '', type: '' },
  { content: '峡谷 / The Gorge', label: '', type: '' },
  { content: '因果报应 / Maharaja', label: '', type: '' },
  { content: '美国丽人 / American Beauty', label: '', type: '' },
];

const finalMovieList = movie.map((item, index) => {
  return {
    ...item,
    label: labelMap[scores[index]],
    type: typeMap[scores[index]],
  };
});

export default finalMovieList;